import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  processStyleMarkupWithoutBreaks(s: string | null | undefined): string | null | undefined {
    return s
      ? this.processStyleMarkup(s)?.replace(/<p>/g, '')
          .replace(/<\/p>/g, ' ')
          .replace(/<br\/>/g, ' ')
          .trim()
      : s;
  }

  processStyleMarkup(s: string | null | undefined): string | null | undefined {
    return s
      ? this.escapeHtml(s)?.split('\n\n')
          .map((value: string) => '<p>'
            + this.prepareLink(value.replace(/\*\*((?:(?!\*\*).)+)\*\*/g, '<span class="fw-bold">$1</span>')
              .replace(/##((?:(?!##).)+)##/g, '<span class="fst-italic">$1</span>')
              .replace(/__((?:(?!__).)+)__/g, '<span class="text-decoration-underline">$1</span>')
              .replace(/@rot@((?:(?!@rot@).)+)@rot@/g, '<span class="text-primary">$1</span>')
              .replace(/\^\^((?:(?!\^\^).)+)\^\^/g, '<span class="small">$1</span>'))
            + '</p>')
          .join('')
          .replace(/\n/g, '<br/>')
      : s;
  }

  removeStyleMarkup(s: string | null | undefined): string | null | undefined {
    return s?.replace(/\*\*/g, '')
      .replace(/##/g, '')
      .replace(/__/g, '')
      .replace(/@rot@/g, '')
      .replace(/\^\^/g, '');
  }

  escapeHtmlWithLink(unsafe: string | null | undefined): string | null | undefined {
    return this.prepareLink(this.escapeHtml(unsafe));
  }

  private escapeHtml(unsafe: string | null | undefined): string | null | undefined {
    return unsafe?.trim()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  prepareLink(s: string | null | undefined): string | null | undefined {
    return s?.replace(/(https?:\/\/([-a-zA-Z\d@:%._+~#=]{1,256})[-a-zA-Z\d()@:%_+.~#?&/=;]*[-a-zA-Z\d@:%_+.~#?&/=;])/g, '<a href="$1" target="_blank">$2</a>');
  }
}
